import { Icon } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import ExpandMenuList from '../../components/expand-menu-list/Expand-Menu-List';
import {
  RBAC_PERMISSION_LEVEL_API_READ_ONLY,
  RBAC_PERMISSION_LEVEL_NO_ACCESS,
} from '../../constants/RoleConsts';
import {
  filteredHotelsSelector,
  selectedHotelSelector,
  allRestaurantSelector,
} from '../../layouts/property/propertySlice';
import { getAccessControl } from '../../utils/RBACUtil';
import { checkAuthState } from '../../utils/APIUtils';
import './Left-bar.scss';

const LeftNavBar = (props) => {
  const { leftMenu, onColapse, expanded } = props;
  const history = useHistory();
  const logo = '/assets/img/hudini-logo-black.png';
  const logoSmall = '/assets/img/hudini-logo-black-small.png';
  const [userRolePermissions, setUserRolePermissions] = useState(null);
  const [cognitoUser, setCognitoUser] = useState(null);
  const selectedHotel = useSelector(selectedHotelSelector);
  const [filteredLeftMenu, setFilteredLeftMenu] = useState(leftMenu);
  const filteredHotelList = useSelector(filteredHotelsSelector);
  const allRestaurants = useSelector(allRestaurantSelector);
  const [currRoute, setCurrRoute] = useState(null);
  const [isCulinaryOperationManager, setIsCulinaryOperationManager] = useState(false);

  useEffect(() => {
    (async () => {
      const currUser = await checkAuthState();
      setCognitoUser(currUser);
      if (
        currUser &&
        currUser?.attributes &&
        currUser?.attributes['custom:role'] === 'CULINARY_OPERATIONS_MANAGER'
      ) {
        setIsCulinaryOperationManager(true);
      }
    })();
  }, []);

  useEffect(() => {
    let routePath = window.location.pathname.split('/')[1];
    if (routePath && routePath.substring(0, 10) === 'dashboard-') {
      routePath = '';
    }
    setCurrRoute(routePath);
  }, [window.location.pathname]);

  useEffect(() => {
    if (leftMenu && leftMenu.length && userRolePermissions) {
      const filterdMenu = leftMenu.filter((menuItem) => {
        return checkAccessLevel(menuItem.permission) && checkHotelLevelAccess(menuItem);
      });
      setFilteredLeftMenu(filterdMenu);
    }
  }, [leftMenu, selectedHotel, userRolePermissions]);

  useEffect(() => {
    if (!userRolePermissions) {
      (async () => {
        try {
          const perms = await getAccessControl();
          setUserRolePermissions(perms);
        } catch (e) {
          console.error(e);
        }
      })();
    }
  }, [userRolePermissions]);

  const redirectTo = (link) => {
    if (window.location.pathname !== link) {
      history.push(link);
    }
  };

  const onExpandCollpaseChange = () => {
    onColapse(!expanded);

    const event = new Event('resize');
    window.dispatchEvent(event);
  };

  const checkAccessLevel = (accessTypes) => {
    if (accessTypes.some((val) => val === 'home')) {
      return true;
    }

    for (const permission in userRolePermissions) {
      if (
        accessTypes?.some((val) => val === permission) &&
        userRolePermissions[permission] > RBAC_PERMISSION_LEVEL_NO_ACCESS &&
        userRolePermissions[permission] < RBAC_PERMISSION_LEVEL_API_READ_ONLY
      ) {
        return true;
      }
    }
    return false;
  };

  const checkHotelLevelAccess = (menuItem) => {
    if (
      cognitoUser &&
      cognitoUser.attributes &&
      cognitoUser.attributes['custom:role'] !== 'SUPER_ADMIN' &&
      menuItem.title === 'Configurations'
    ) {
      if (!menuItem.checkHotelAccess) {
        return true;
      } else {
        if (selectedHotel && menuItem.hotelCheckField) {
          const selectedHotelDetails = filteredHotelList.find((hotel) => hotel.id === selectedHotel);
          return selectedHotelDetails && selectedHotelDetails[menuItem.hotelCheckField];
        } else {
          return false;
        }
      }
    } else {
      return true;
    }
  };

  const onRestrictedCheck = (menuItem) => {
    if (isCulinaryOperationManager && allRestaurants.length === 0) {
      return true;
    }
    return (
      (menuItem?.title === 'Dashboard' ||
        menuItem?.title === 'Analytics' ||
        menuItem?.title === 'Statistics' ||
        menuItem?.title === 'Design Configs') &&
      !selectedHotel
    );
  };
  return (
    <>
      {userRolePermissions && (
        <div className={`${expanded ? 'expanded scroll-styled' : 'collapsed'} `}>
          <div className='left-bar'>
            <div className='left-bar-logo px-3 pt-4 pb-3 d-flex justify-content-start align-items-center'>
              <span className='btn-exp-collapse pe-3' onClick={(e) => onExpandCollpaseChange()}>
                <i className={`fa ${expanded ? 'fa-caret-left' : 'fa-caret-right'}`}></i>
              </span>
              <img src={expanded ? logo : logoSmall} className='header-logo m-0' alt='logo' />
            </div>
            <div className='left-bar-menu scroll-styled'>
              {filteredLeftMenu.map((menuItem, key) => (
                <div key={key}>
                  {menuItem?.children ? (
                    <ExpandMenuList
                      menuItem={menuItem}
                      menuExpanded={expanded}
                      onColapse={onColapse}
                      permissions={userRolePermissions}
                      isDisableMenu={isCulinaryOperationManager && allRestaurants.length === 0}
                    ></ExpandMenuList>
                  ) : (
                    <div
                      className={`${
                        menuItem.route.split('/')[1] === currRoute
                          ? 'left-bar-menu-item-selected'
                          : 'left-bar-menu-item'
                      }  ${
                        onRestrictedCheck(menuItem) ? 'disable-item' : ''
                      } d-flex align-items-center showpopup`}
                      title={menuItem.title}
                      key={menuItem.title}
                      onClick={(e) => {
                          redirectTo(menuItem.route);
                      }}
                    >
                      <Icon className='showpopup' fontSize='small'>
                        {menuItem.icon}
                      </Icon>
                      {expanded && (
                        <>
                          <span className='menu-item-title showpopup text-nowrap'>
                            {menuItem.title}
                          </span>
                          {menuItem.title === 'Analytics' && (
                            <span className='left-bar-beta'>Beta</span>
                          )}
                        </>
                      )}
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default LeftNavBar;
